
import { TinyMceEditorController } from 'src/shared/wysiwyg/tinymce/TinyMceEditorController';
import { getDisplayableElement } from 'src/shared/wysiwyg/WysiwygFeedbackUtil';

export class GenericTinyMceEditorController extends TinyMceEditorController {
    constructor(
        baseUrl: string,
        i18n: any,
        facade: any,
        hideAccessibilityPlugin: boolean
    ) {
        super(baseUrl, i18n, facade, hideAccessibilityPlugin);
    }

    public async onSelection(selectedElement?: HTMLElement): Promise<void> {
        const value = getDisplayableElement(selectedElement);
        this.emitter.emit('selection-changed', value);
    }
}
